(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holae-spa-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Árbol del Selector spa.xlsx (Holae) */
  var SELECTOR = {
    hinchable: {
      '4': {
        step: 'prio-h4',
        map: {
          precio: ['Camaro 6', 'Bristol', 'Vento'],
          jets: ['Indigo', 'Nox'],
          resistencia: ['Duet', 'Naval', 'Mono 8', 'Nox']
        }
      },
      '6': {
        step: 'prio-h6',
        map: {
          precio: ['Duet', 'Naval'],
          espacio: ['Mono 8'],
          jets: ['Nox']
        }
      },
      '8': {
        models: ['Mono Eco 8']
      }
    },
    semi: {
      '4': {
        step: 'shape',
        shape: {
          redonda: { models: ['Denver', 'Rova'] },
          cuadrada: {
            step: 'prio-s4',
            map: {
              precio: ['Oslo', 'Oslo Sapphire'],
              espacio: ['Oslo Aero Plus', 'Amber Aero Plus']
            }
          }
        }
      },
      '6': {
        step: 'shape',
        shape: {
          cuadrada: { models: ['Oslo Aero Plus', 'Amber Aero Plus'] },
          redonda: { models: ['Denver', 'Rova'] }
        }
      }
    }
  };

  var FALLBACK = [
    { id: 'bristol', variantId: null, type: 'hinchable', title: 'Spa Bristol Ø204 cm', priceEur: 429, img: '', url: '/products/bristol', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo (colección no configurada).' },
    { id: 'vento', variantId: null, type: 'hinchable', title: 'Spa Vento Ø204 cm', priceEur: 449, img: '', url: '/products/vento', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo (colección no configurada).' },
    { id: 'camaro-6', variantId: null, type: 'hinchable', title: 'Spa Camaro 6', priceEur: 799, img: '', url: '/products/camaro', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo (colección no configurada).' },
    { id: 'indigo', variantId: null, type: 'hinchable', title: 'Spa Indigo', priceEur: 899, img: '', url: '/collections/all', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo.' },
    { id: 'nox', variantId: null, type: 'hinchable', title: 'Spa Nox', priceEur: 1099, img: '', url: '/collections/all', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo.' },
    { id: 'duet', variantId: null, type: 'hinchable', title: 'Spa Duet', priceEur: 999, img: '', url: '/collections/all', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo.' },
    { id: 'naval', variantId: null, type: 'hinchable', title: 'Spa Naval', priceEur: 1199, img: '', url: '/collections/all', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo.' },
    { id: 'mono-8', variantId: null, type: 'hinchable', title: 'Spa Mono 8', priceEur: 1299, img: '', url: '/collections/all', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo.' },
    { id: 'mono-eco-8', variantId: null, type: 'hinchable', title: 'Spa Mono Eco 8', priceEur: 1399, img: '', url: '/collections/all', kicker: 'Spa Hinchable', reason: 'Modelo de ejemplo.' },
    { id: 'oslo', variantId: null, type: 'semi', title: 'Spa Oslo', priceEur: 2190, img: '', url: '/collections/all', kicker: 'Spa Semi-rígido', reason: 'Modelo de ejemplo.' },
    { id: 'oslo-sapphire', variantId: null, type: 'semi', title: 'Spa Oslo Sapphire', priceEur: 2490, img: '', url: '/collections/all', kicker: 'Spa Semi-rígido', reason: 'Modelo de ejemplo.' },
    { id: 'oslo-aero-plus', variantId: null, type: 'semi', title: 'Spa Oslo Aero Plus', priceEur: 2890, img: '', url: '/collections/all', kicker: 'Spa Semi-rígido', reason: 'Modelo de ejemplo.' },
    { id: 'amber-aero-plus', variantId: null, type: 'semi', title: 'Spa Amber Aero Plus', priceEur: 3090, img: '', url: '/collections/all', kicker: 'Spa Semi-rígido', reason: 'Modelo de ejemplo.' },
    { id: 'denver', variantId: null, type: 'semi', title: 'Spa Denver', priceEur: 2590, img: '', url: '/collections/all', kicker: 'Spa Semi-rígido', reason: 'Modelo de ejemplo.' },
    { id: 'rova', variantId: null, type: 'semi', title: 'Spa Rova', priceEur: 2690, img: '', url: '/collections/all', kicker: 'Spa Semi-rígido', reason: 'Modelo de ejemplo.' },
    { id: 'forma', variantId: null, type: 'semi', title: 'Spa Forma', priceEur: 2790, img: '', url: '/collections/all', kicker: 'Spa Semi-rígido', reason: 'Modelo de ejemplo.' }
  ];

  var imgCache = {};

  function formatEur(n) {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n || 0);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, '&#39;');
  }

  var IMG_PLACEHOLDER =
    'data:image/svg+xml,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90"><rect width="90" height="90" fill="#e8ecf2"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#9aa3b2" font-family="sans-serif" font-size="11">Spa</text></svg>'
    );

  function productImg(prod) {
    return prod && prod.img ? String(prod.img) : IMG_PLACEHOLDER;
  }

  function fetchProductImg(handle) {
    if (!handle) return Promise.resolve('');
    if (imgCache[handle]) return Promise.resolve(imgCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product not found');
        return r.json();
      })
      .then(function (data) {
        var url = data.featured_image || (data.images && data.images.length ? data.images[0] : '') || '';
        imgCache[handle] = url;
        return url;
      })
      .catch(function () {
        imgCache[handle] = '';
        return '';
      });
  }

  function enrichProducts(products) {
    return Promise.all(
      products.map(function (prod) {
        if (prod.img) return Promise.resolve(prod);
        return fetchProductImg(prod.id).then(function (url) {
          if (url) prod.img = url;
          return prod;
        });
      })
    );
  }

  function setResultImage(imgEl, prod) {
    if (!imgEl) return;
    var url = productImg(prod);
    imgEl.onerror = function () {
      imgEl.onerror = null;
      imgEl.src = IMG_PLACEHOLDER;
    };
    imgEl.src = url;
    imgEl.alt = prod && prod.title ? prod.title : 'Producto recomendado';
  }

  function getPool(root) {
    var el = root.querySelector('[data-holae-quiz-products]');
    if (!el) return { products: FALLBACK, isFallback: true };
    try {
      var data = JSON.parse(el.textContent || '[]');
      if (data.length) return { products: data, isFallback: false };
      return { products: FALLBACK, isFallback: true };
    } catch (e) {
      return { products: FALLBACK, isFallback: true };
    }
  }

  function titleMatchesModel(title, model) {
    var t = String(title || '').toLowerCase();
    var m = String(model || '').toLowerCase().trim();
    if (!t || !m) return false;

    if (m === 'oslo') {
      return /\boslo\b/.test(t) && !/sapphire/.test(t) && !/aero/.test(t);
    }
    if (m === 'mono 8') {
      return /\bmono\s*8\b/.test(t) && !/eco/.test(t);
    }
    if (m === 'mono eco 8') {
      return /\bmono\s*eco\s*8\b/.test(t);
    }
    if (m === 'camaro 6') {
      return /\bcamaro\s*6\b/.test(t) || (/\bcamaro\b/.test(t) && /\b6\b/.test(t));
    }

    var escaped = m.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s*');
    return new RegExp(escaped, 'i').test(t);
  }

  function resolveModels(answers) {
    var type = answers.type;
    var seats = answers.seats;
    var prio = answers.prio;
    var shape = answers.shape;
    if (!type || !seats || !SELECTOR[type] || !SELECTOR[type][seats]) return [];

    var node = SELECTOR[type][seats];
    if (node.models) return node.models.slice();

    if (node.shape) {
      if (!shape || !node.shape[shape]) return [];
      var sn = node.shape[shape];
      if (sn.models) return sn.models.slice();
      if (sn.map && prio && sn.map[prio]) return sn.map[prio].slice();
      return [];
    }

    if (node.map && prio && node.map[prio]) return node.map[prio].slice();
    return [];
  }

  function nextStepAfter(answers) {
    if (!answers.type) return 'type';
    if (!answers.seats) return 'seats';

    var node = SELECTOR[answers.type] && SELECTOR[answers.type][answers.seats];
    if (!node) return 'done';
    if (node.models) return 'done';

    if (node.step === 'prio-h4' || node.step === 'prio-h6') {
      if (!answers.prio) return node.step;
      return 'done';
    }

    if (node.step === 'shape') {
      if (!answers.shape) return 'shape';
      var sn = node.shape[answers.shape];
      if (!sn) return 'done';
      if (sn.models) return 'done';
      if (sn.step === 'prio-s4') {
        if (!answers.prio) return 'prio-s4';
        return 'done';
      }
      return 'done';
    }

    return 'done';
  }

  function pathLength(answers) {
    var type = answers.type;
    var seats = answers.seats;
    if (!type) return 2;
    if (type === 'hinchable' && seats === '8') return 2;
    if (type === 'hinchable') return 3;
    if (type === 'semi' && seats === '4') {
      if (answers.shape === 'cuadrada') return 4;
      return 3;
    }
    if (type === 'semi') return 3;
    return 3;
  }

  function pickProducts(pool, answers) {
    var models = resolveModels(answers);
    var typed = pool.filter(function (p) {
      return p.type === answers.type;
    });
    var source = typed.length ? typed : pool;
    var found = [];
    var seen = {};

    models.forEach(function (model) {
      source.forEach(function (prod) {
        if (seen[prod.id]) return;
        if (!titleMatchesModel(prod.title, model) && !titleMatchesModel(prod.id, model)) return;
        seen[prod.id] = 1;
        found.push(prod);
      });
    });

    return found.slice(0, 3);
  }

  function initQuiz(root) {
    var poolInfo = getPool(root);
    var pool = poolInfo.products;
    var isFallback = poolInfo.isFallback;
    var donePanel = root.querySelector('[data-quiz-done]');
    var progBars = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-progress]'));
    var label = root.querySelector('[data-quiz-label]');
    var answers = {};
    var history = [];
    var top3 = [];
    var totalSteps = 3;

    function currentStepId() {
      return history.length ? history[history.length - 1] : 'type';
    }

    function setProg(doneCount) {
      progBars.forEach(function (bar, p) {
        bar.classList.toggle('is-unused', p >= totalSteps);
        bar.classList.toggle('is-done', p < doneCount && p < totalSteps);
      });
      var prog = root.querySelector('[role="progressbar"]');
      if (prog) {
        prog.setAttribute('aria-valuemax', String(totalSteps));
        prog.setAttribute('aria-valuenow', String(Math.min(doneCount + 1, totalSteps)));
      }
    }

    function filterSeatsButtons() {
      var type = answers.type || 'hinchable';
      root.querySelectorAll('[data-seats-for]').forEach(function (btn) {
        var allowed = (btn.getAttribute('data-seats-for') || '').split(',');
        btn.hidden = allowed.indexOf(type) === -1;
      });
    }

    function showStep(stepId) {
      root.querySelectorAll('[data-quiz-step]').forEach(function (step) {
        step.setAttribute('data-hidden', step.getAttribute('data-quiz-step') === stepId ? 'false' : 'true');
      });
      if (donePanel) donePanel.setAttribute('data-hidden', 'true');
      if (stepId === 'seats') filterSeatsButtons();
      totalSteps = pathLength(answers);
      var stepNum = history.length;
      if (label) label.textContent = 'PASO ' + Math.max(stepNum, 1) + '/' + totalSteps;
      setProg(Math.max(stepNum - 1, 0));
    }

    function showDone() {
      root.querySelectorAll('[data-quiz-step]').forEach(function (step) {
        step.setAttribute('data-hidden', 'true');
      });
      if (donePanel) donePanel.setAttribute('data-hidden', 'false');
      if (label) label.textContent = 'LISTO · TU SPA';
      totalSteps = pathLength(answers);
      setProg(totalSteps);
      top3 = pickProducts(pool, answers);
      if (!top3.length && !isFallback) {
        top3 = pickProducts(FALLBACK, answers);
        isFallback = true;
      }
      enrichProducts(top3).then(function () {
        renderResult();
      });
    }

    function goNext(pick) {
      if (!pick) return;
      var parts = String(pick).split(':');
      var key = parts[0];
      var val = parts.slice(1).join(':');
      answers[key] = val;

      if (key === 'type') {
        delete answers.seats;
        delete answers.prio;
        delete answers.shape;
      }
      if (key === 'seats') {
        delete answers.prio;
        delete answers.shape;
      }
      if (key === 'shape') {
        delete answers.prio;
      }

      var next = nextStepAfter(answers);
      if (next === 'done') {
        history.push('done');
        showDone();
        return;
      }
      history.push(next);
      showStep(next);
    }

    function goBack() {
      if (history.length <= 1) {
        answers = {};
        history = ['type'];
        showStep('type');
        return;
      }
      history.pop();
      var prev = history[history.length - 1];
      if (prev === 'type') {
        answers = {};
      } else if (prev === 'seats') {
        delete answers.seats;
        delete answers.prio;
        delete answers.shape;
      } else if (prev === 'shape') {
        delete answers.shape;
        delete answers.prio;
      } else if (prev.indexOf('prio') === 0) {
        delete answers.prio;
      }
      showStep(prev);
    }

    function renderResult() {
      var main = top3[0];
      var fallbackNote = root.querySelector('[data-quiz-fallback-note]');
      if (fallbackNote) fallbackNote.hidden = !isFallback;

      if (!main) {
        var titleEmpty = root.querySelector('[data-quiz-result-title]');
        var reasonEmpty = root.querySelector('[data-quiz-result-reason]');
        if (titleEmpty) titleEmpty.textContent = 'No encontramos coincidencias';
        if (reasonEmpty) {
          reasonEmpty.textContent =
            'Revisa que la colección tenga spas con esos modelos en el título, o que estén etiquetados como hinchable / semi.';
        }
        return;
      }

      var thumb = root.querySelector('[data-quiz-result-thumb]');
      var thumbLink = root.querySelector('[data-quiz-result-thumb-link]');
      var kicker = root.querySelector('[data-quiz-result-kicker]');
      var title = root.querySelector('[data-quiz-result-title]');
      var price = root.querySelector('[data-quiz-result-price]');
      var link = root.querySelector('[data-quiz-result-link]');
      var reason = root.querySelector('[data-quiz-result-reason]');
      var more = root.querySelector('[data-quiz-result-more]');
      var addBtn = root.querySelector('[data-quiz-add-cart]');
      var cmpLink = root.querySelector('[data-quiz-compare-link]');
      var mainUrl = main.url || '#';

      setResultImage(thumb, main);
      if (thumbLink) thumbLink.href = mainUrl;
      if (kicker) kicker.textContent = main.kicker || '';
      if (title) title.textContent = main.title || '';
      if (price) price.textContent = formatEur(main.priceEur);
      if (link) {
        link.href = mainUrl;
        link.textContent = 'Ver ficha · ' + (main.title || '').split(' ').slice(0, 4).join(' ') + ' →';
      }
      if (reason) reason.textContent = main.reason || '';
      if (addBtn) addBtn.dataset.variantId = main.variantId || '';

      if (more) {
        more.innerHTML = '';
        ['2 · Siguiente opción', '3 · Tercera opción'].forEach(function (rankLabel, ri) {
          var prod = top3[ri + 1];
          if (!prod) return;
          var prodUrl = prod.url || '#';
          var row = document.createElement('div');
          row.className = 'holae-quiz__result-row';
          row.innerHTML =
            '<div class="holae-quiz__result-row-top">' +
            '<a class="holae-quiz__result-row-thumb" href="' +
            escapeAttr(prodUrl) +
            '" tabindex="-1" aria-hidden="true">' +
            '<img src="' +
            escapeAttr(productImg(prod)) +
            '" alt="' +
            escapeAttr(prod.title || '') +
            '" width="64" height="64" loading="lazy" decoding="async">' +
            '</a>' +
            '<div><span class="holae-quiz__result-rank">' +
            escapeHtml(rankLabel) +
            '</span>' +
            '<div class="holae-quiz__result-kicker">' +
            escapeHtml(prod.kicker) +
            '</div>' +
            '<div class="holae-quiz__result-name" style="font-size:15px">' +
            escapeHtml(prod.title) +
            '</div>' +
            '<div class="holae-quiz__result-price"><span style="font-size:18px">' +
            escapeHtml(formatEur(prod.priceEur)) +
            '</span></div>' +
            '</div></div>' +
            '<a class="holae-quiz__btn holae-quiz__btn--ghost holae-quiz__btn--inline" href="' +
            escapeAttr(prodUrl) +
            '">Ver ficha →</a>';
          var rowImg = row.querySelector('img');
          if (rowImg) {
            rowImg.onerror = function () {
              rowImg.onerror = null;
              rowImg.src = IMG_PLACEHOLDER;
            };
          }
          more.appendChild(row);
        });
      }

      if (cmpLink && top3.length) {
        var handles = top3
          .map(function (p) {
            return p.id;
          })
          .filter(Boolean)
          .join(',');
        var base = cmpLink.getAttribute('href') || '';
        cmpLink.href = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'compare=' + encodeURIComponent(handles);
        cmpLink.hidden = false;
      }
    }

    root.querySelectorAll('[data-quiz-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goNext(btn.getAttribute('data-quiz-pick') || '');
      });
    });

    root.querySelectorAll('[data-quiz-back]').forEach(function (btn) {
      btn.addEventListener('click', goBack);
    });

    var resetBtn = root.querySelector('[data-quiz-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        answers = {};
        history = ['type'];
        isFallback = poolInfo.isFallback;
        showStep('type');
      });
    }

    var addBtn = root.querySelector('[data-quiz-add-cart]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.location.href = '/cart';
          })
          .catch(function () {
            addBtn.classList.remove('is-loading');
          });
      });
    }

    history = ['type'];
    showStep('type');
  }

  document.querySelectorAll('.holae-spa-quiz').forEach(initQuiz);
})();

  } catch(e) { console.error(e); }
})();
})();
